import React from "react";

type EntryMode = "wizard" | "snabb";

type Props = {
  entryMode: EntryMode;
  setEntryMode: (mode: EntryMode) => void;
  isCustomerPortal: boolean;
  children: React.ReactNode;
};

/**
 * Gemensam wrapper för hem-sidan: rubrik, lägesväljare (wizard/snabbinmatning)
 * och layout runt respektive vy. Beteendet matchar tidigare inline-struktur i App.tsx.
 */
export function HomeShell({ entryMode, setEntryMode, isCustomerPortal, children }: Props): JSX.Element | null {
  if (isCustomerPortal) return null;

  const shellClassName = entryMode === 'snabb'
    ? "max-w-[1180px] mx-auto px-3"
    : "max-w-[600px] mx-auto";

  return (
    <div className={shellClassName}>
      {children}
    </div>
  );
}
